import { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import { CURRENCIES, type CurrencyCode } from '../../types';

interface EventFormProps {
  onSubmit: (name: string, currency: CurrencyCode) => void;
  onCancel: () => void;
  initialName?: string;
  initialCurrency?: CurrencyCode;
  submitLabel?: string;
}

export function EventForm({
  onSubmit,
  onCancel,
  initialName = '',
  initialCurrency = 'ARS',
  submitLabel = 'Crear evento',
}: EventFormProps) {
  const [name, setName] = useState(initialName);
  const [currency, setCurrency] = useState<CurrencyCode>(initialCurrency);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (name.trim()) {
      onSubmit(name.trim(), currency);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="name">Nombre del evento</Label>
        <Input
          id="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Ej: Cena del viernes"
          autoFocus
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="currency">Moneda</Label>
        <Select value={currency} onValueChange={(v) => setCurrency(v as CurrencyCode)}>
          <SelectTrigger id="currency">
            <SelectValue placeholder="Seleccionar moneda" />
          </SelectTrigger>
          <SelectContent>
            {CURRENCIES.map((c) => (
              <SelectItem key={c.code} value={c.code}>
                {c.symbol} {c.name} ({c.code})
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {!name.trim() && (
        <p className="text-sm text-muted-foreground">Ingresa un nombre para el evento</p>
      )}

      <div className="flex gap-2 pt-2">
        <Button type="button" variant="outline" onClick={onCancel} className="flex-1">
          Cancelar
        </Button>
        <Button type="submit" disabled={!name.trim()} className="flex-1">
          {submitLabel}
        </Button>
      </div>
    </form>
  );
}
